import React from 'react';
import EventList from '../components/EventList';
import { eventsAPI } from '../services/api';

const LatestEvents = () => {
  return (
    <EventList 
      fetchEvents={eventsAPI.getLatestEvents} 
      title="Latest Events" 
    />
  );
};

export default LatestEvents;